function parseParams(uri, startToken) {
  const result = {}
  const searchArr = uri.split(startToken)
  if (searchArr[1]) {
    const params = searchArr[1].split('&')
    params.forEach(param => {
      const keyVal = param.split('=')
      result[keyVal[0]] = recursivelyDecodeURIComponent(keyVal[1])
    })
  }
  return result
}

export function parseQueryParams(search) {
  return parseParams(search, '?')
}

export function recursivelyDecodeURIComponent(uri) {
  try {
    const decodedUri = decodeURIComponent(uri)
    if (uri === decodedUri) {
      return uri
    }
    return recursivelyDecodeURIComponent(decodedUri)
  } catch (e) {
    console.error(e)
    // Cannot decode any further (likely contains % in the original string)
    return uri
  }
}

export default function urlReplace(text, style) {
  var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g
  return text.replace(urlRegex, function (url, b, c) {
    var url2 = (c === 'www.') ? 'http://' + url : url
    return '<a style="' + style + '" href="' + url2 + '" target="_blank">' + url + '</a>'
  })
}
